

import { CustomTooltipInterface } from '../../Models/Common/CustomViewsInterfaces';
import GlobalFunctionHelper from '../../Utilities/Helpers/GlobalFunctionHelper';
import { Tooltip } from '@mui/material';

const CustomTooltip = (customTooltipProps: CustomTooltipInterface) => {
	const { placement, tooltipName, tooltipClass, tooltipContent, ...otherProps } = customTooltipProps;
	let _placement = (placement ? placement : 'bottom'),
		textContent = (tooltipName != null && tooltipName != "" ?
			tooltipName : null
		);

	return <Tooltip {...otherProps}
		key={tooltipClass != null && tooltipClass != "" ? tooltipClass + "ToolTip" : GlobalFunctionHelper.getRanHex(24)}
		placement={_placement}
		title={<span style={{ fontSize: '13px', color: 'FFFFFF !important' }}>{textContent}</span>}
		arrow={true}
	>
		{tooltipContent}
	</Tooltip>
}

export default CustomTooltip;